import React from 'react';
import { Global } from '@emotion/react'

const Fonts = () => (
  <Global
    styles={`
      @font-face {
        font-family: 'kdwnormal';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('/static/fonts/space-grotesk-v13-latin-regular.woff2') format('woff2'), url('/static/fonts/space-grotesk-v13-latin-regular.woff') format('woff');
      }
      `}
  />
)

export default Fonts